import api from './axiosInstance';

export const obtenerPdf = async (url: string) => {
    const response = await api.get(url, {
        responseType: "blob",
    });

    return response.data; // blob
};
